interface FormDataConfig {
    maxDepth?: number;
    excludeKeys?: string[];
    arrayFormat?: "brackets" | "indices";
}

export function toFormData(data: any, config: FormDataConfig = {}): FormData {
    const formData = new FormData();

    const { maxDepth = Infinity, excludeKeys = ["photos", "delete_photos"], arrayFormat = "brackets" } = config;

    function processValue(key: string, value: unknown, depth: number = 0): void {
        if (depth > maxDepth) {
            throw new Error(`Превышена максимальная глубина вложенности для ключа ${key}`);
        }

        if (excludeKeys.includes(key)) return;

        if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === null) {
            formData.append(key, String(value));
            return;
        }

        if (value instanceof File) {
            formData.append(key, value);
            return;
        }

        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                const newKey = `${key}[${index}]`;
                processValue(newKey, item, depth + 1);
            });
            return;
        }

        if (typeof value === "object" && value !== null) {
            Object.entries(value).forEach(([subKey, subValue]) => {
                const newKey = `${key}[${subKey}]`;
                processValue(newKey, subValue, depth + 1);
            });
            return;
        }

        formData.append(key, String(value));
    }

    try {
        Object.entries(data).forEach(([key, value]) => {
            processValue(key, value);
        });
        return formData;
    } catch (error) {
        throw new Error(`Ошибка при конвертации в FormData: ${String(error)}`);
    }
}
// export const toFormData = (data: any) => {
//     const notAddKey = ["photos", "delete_photos"];
//     const dataType: Record<string, any> = data;
//     const formData = new FormData();
//     Object.keys(dataType).forEach((key: string) => {
//         if (
//             typeof dataType[key] === "object" &&
//             dataType[key] !== null &&
//             dataType[key] !== "undefined" &&
//             !notAddKey.includes(key)
//         ) {
//             if (Array.isArray(dataType[key]) && typeof dataType[key][0] === "object") {
//                 dataType[key].forEach((elem: any, index: any) => {
//                     if (elem instanceof File) {
//                         formData.append(`${key}[${index}]`, elem);
//                     } else {
//                         elem &&
//                             Object.keys(elem).forEach(innerKey =>
//                                 formData.append(`${key}[${index}][${innerKey}]`, elem[innerKey]),
//                             );
//                     }
//                 });
//             } else {
//                 Object.keys(dataType[key]).forEach((innerKey: string) => {
//                     formData.append(`${key}[${innerKey}]`, dataType[key][innerKey]);
//                 });
//             }
//         } else if (!notAddKey.includes(key)) {
//             // if (key === "delete_photos") {
//             //     dataType[key].forEach((v: any, index: Number) => {
//             //         formData.append(`${key}[${index}]`, v);
//             //     });
//             // }
//             formData.append(key, dataType[key]);
//         }
//     });
//     return formData;
// };
